import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../styles/menu.scss";
import { FaRegEdit } from "react-icons/fa";
import { toast } from "react-toastify";

const Usuario = () => {
    const [usuarios, setUser] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(""); // "edit" ou "add"
    const [currentUsuario, setCurrentUsuario] = useState(null);
    const [newUsuario, setNewUsuario] = useState({
        ID_TP_USER: "",
        NOME: "",
        SOBRENOME: "",
        EMAIL: "",
        LOGIN: "",
        SENHA: "",
        FL_ATIVO: true,
    });
    const [searchTerm, setSearchTerm] = useState("");

    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchUsuario = async () => {
            const API_URL = process.env.REACT_APP_API_URL; // Definir aqui
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    throw new Error("Usuario nao autenticado.");
                }

                const response = await axios.get(`${API_URL}/api/menu/usuarios`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                setUser(
                    response.data.map((usuario) => ({
                        ...usuario,
                        FL_ATIVO: Boolean(usuario.FL_ATIVO),
                        NOME_COMPLETO:
                            usuario.NOME_COMPLETO ||
                            `${usuario.NOME || ""} ${usuario.SOBRENOME || ""}`.trim(),
                    }))
                );
            } catch (error) {
                console.error("Erro ao buscar usuarios:", error.response?.data || error.message);
                if (error.response?.status === 401) {
                    navigate("/login");
                }
            }
        };

        fetchUsuario();
    }, [navigate]);

    const handleEdit = (usuario) => {
        setCurrentUsuario({
            ...usuario,
            FL_ATIVO: Boolean(usuario.FL_ATIVO),
        });
        setModalType("edit");
        setModalOpen(true);
    };

    const handleAdd = () => {
        setNewUsuario({
            ID_TP_USER: "",
            NOME: "",
            SOBRENOME: "",
            EMAIL: "",
            LOGIN: "",
            SENHA: "",
            FL_ATIVO: true,
        });
        setModalType("add");
        setModalOpen(true);
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem("authToken");

            if (modalType === "edit") {
                if (!currentUsuario?.ID_USERS) {
                    throw new Error("ID_USERS nao encontrado!");
                }

                const payload = {
                    NOME: currentUsuario.NOME,
                    SOBRENOME: currentUsuario.SOBRENOME,
                    EMAIL: currentUsuario.EMAIL,
                    LOGIN: currentUsuario.LOGIN,
                    SENHA: currentUsuario.SENHA || undefined, // Nao enviar SENHA se estiver vazia
                    ID_TP_USER: currentUsuario.ID_TP_USER,
                    FL_ATIVO: currentUsuario.FL_ATIVO ? 1 : 0,
                    ID_USERS: currentUsuario.ID_USERS,
                };

                await axios.put(
                    `${API_URL}/api/menu/usuarios/${currentUsuario.ID_USERS}`,
                    payload,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                toast.success("Usuario editado com sucesso!");
            } else if (modalType === "add") {
                const normalizedLogin = (newUsuario.LOGIN || "").trim().toLowerCase();
                const normalizedEmail = (newUsuario.EMAIL || "").trim().toLowerCase();
                const usuarioDuplicado = usuarios.some(
                    (usuario) =>
                        usuario.LOGIN?.toLowerCase() === normalizedLogin ||
                        usuario.EMAIL?.toLowerCase() === normalizedEmail
                );

                if (usuarioDuplicado) {
                    toast.error("Ja existe um usuario com este login ou e-mail.");
                    return;
                }

                const payload = {
                    NOME: newUsuario.NOME,
                    SOBRENOME: newUsuario.SOBRENOME,
                    EMAIL: newUsuario.EMAIL,
                    LOGIN: newUsuario.LOGIN,
                    SENHA: newUsuario.SENHA,
                    ID_TP_USER: newUsuario.ID_TP_USER,
                    FL_ATIVO: newUsuario.FL_ATIVO ? 1 : 0,
                };
                await axios.post(`${API_URL}/api/menu/usuarios`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                toast.success("Usuario criado com sucesso!");
            }

            setModalOpen(false);

            // Recarregar os usuarios
            const response = await axios.get(`${API_URL}/api/menu/usuarios`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setUser(
                response.data.map((usuario) => ({
                    ...usuario,
                    FL_ATIVO: Boolean(usuario.FL_ATIVO),
                    NOME_COMPLETO:
                        usuario.NOME_COMPLETO ||
                        `${usuario.NOME || ""} ${usuario.SOBRENOME || ""}`.trim(),
                }))
            );
        } catch (error) {
            console.error("Erro ao salvar usuario:", error);
            toast.error("Erro ao salvar usuario:", error.response?.data || error.message);
        }
    };

    const handleCancel = () => {
        setModalOpen(false);
        setCurrentUsuario(null);
    };

    const handleInputChange = (e, fieldName) => {
        const { value, type, checked } = e.target;
        const parsedValue = type === "checkbox" ? checked : value;

        if (modalType === "edit") {
            setCurrentUsuario((prevUsuario) => ({
                ...prevUsuario,
                [fieldName]: parsedValue,
            }));
        } else {
            setNewUsuario((prevUsuario) => ({
                ...prevUsuario,
                [fieldName]: parsedValue,
            }));
        }
    };

    const usuariosFiltrados = usuarios.filter((usuario) => {
        const termo = searchTerm.toLowerCase();
        return (
            usuario.NOME?.toLowerCase().includes(termo) ||
            usuario.SOBRENOME?.toLowerCase().includes(termo) ||
            usuario.NOME_COMPLETO?.toLowerCase().includes(termo) ||
            usuario.EMAIL?.toLowerCase().includes(termo) ||
            usuario.LOGIN?.toLowerCase().includes(termo)
        );
    });

    return (
        <div className="page-container">
            <h1>Usuarios</h1>
            <div className="usuario-actions">
                <button className="login100-form-btn_cad" onClick={handleAdd}>
                    Cadastrar Novo Usuario
                </button>
                <input
                    className="usuario-search"
                    type="text"
                    placeholder="Pesquisar por nome, sobrenome, e-mail ou login"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>email</th>
                        <th>Login</th>
                        <th>Senha</th>
                        <th>Tipo</th>
                        <th>Ativo</th>
                        <th>Acoes</th>
                    </tr>
                </thead>
                <tbody>
                    {usuariosFiltrados.map((usuario) => (
                        <tr key={usuario.ID_USERS}>
                            <td>{usuario.NOME_COMPLETO || usuario.NOME}</td>
                            <td>{usuario.EMAIL}</td>
                            <td>{usuario.LOGIN}</td>
                            <td>{usuario.SENHA ? "*".repeat(10) : ""}</td>
                            <td>{usuario.TIPO_USER}</td>
                            <td>{usuario.FL_ATIVO ? "Sim" : "Nao"}</td>
                            <td>
                                <button onClick={() => handleEdit(usuario)}>{<FaRegEdit />}</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Modal */}
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>{modalType === "edit" ? "Editar Usuario" : "Cadastrar Usuario"}</h2>

                        {/* Nome */}
                        <label>
                            Nome:
                            <input
                                type="text"
                                value={modalType === "edit" ? currentUsuario?.NOME : newUsuario.NOME}
                                onChange={(e) => handleInputChange(e, "NOME")}
                            />
                        </label>

                        {/* Sobrenome */}
                        <label>
                            Sobrenome:
                            <input
                                type="text"
                                value={modalType === "edit" ? currentUsuario?.SOBRENOME : newUsuario.SOBRENOME}
                                onChange={(e) => handleInputChange(e, "SOBRENOME")}
                            />
                        </label>

                        {/* Email */}
                        <label>
                            Email:
                            <input
                                type="email"
                                value={modalType === "edit" ? currentUsuario?.EMAIL : newUsuario.EMAIL}
                                onChange={(e) => handleInputChange(e, "EMAIL")}
                            />
                        </label>

                        {/* Login */}
                        <label>
                            Login:
                            <input
                                type="text"
                                value={modalType === "edit" ? currentUsuario?.LOGIN : newUsuario.LOGIN}
                                onChange={(e) => handleInputChange(e, "LOGIN")}
                            />
                        </label>

                        {/* Senha */}
                        <label>
                            Senha:
                            <input
                                type="password"
                                value={modalType === "edit" ? currentUsuario?.SENHA : newUsuario.SENHA}
                                onChange={(e) => handleInputChange(e, "SENHA")}
                                onFocus={() => {
                                    if (modalType === "edit") {
                                        setCurrentUsuario((prevUsuario) => ({
                                            ...prevUsuario,
                                            SENHA: "",
                                        }));
                                    } else {
                                        setNewUsuario((prevUsuario) => ({
                                            ...prevUsuario,
                                            SENHA: "",
                                        }));
                                    }
                                }}
                            />
                        </label>

                        {/* Tipo de Usuario */}
                        <label>
                            Tipo de Usuario:
                            <select
                                value={modalType === "edit" ? currentUsuario?.ID_TP_USER : newUsuario.ID_TP_USER}
                                onChange={(e) => handleInputChange(e, "ID_TP_USER")}
                            >
                                <option value="">Selecione</option>
                                <option value="2">Administrador</option>
                                <option value="3">Operacao</option>
                                <option value="3">Gestao</option>
                            </select>
                        </label>

                        {/* Ativo */}
                        <label className="checkbox-field">
                            Ativo:
                            <input
                                type="checkbox"
                                checked={modalType === "edit" ? Boolean(currentUsuario?.FL_ATIVO) : newUsuario.FL_ATIVO}
                                onChange={(e) => handleInputChange(e, "FL_ATIVO")}
                            />
                        </label>

                        {/* Acoes */}
                        <div className="modal-actions">
                            <button onClick={handleSave}>Salvar</button>
                            <button onClick={handleCancel}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Usuario;
